Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Strava", {
  enumerable: true,
  get: function get() {
    return _strava.Strava;
  }
});
var _strava = require("./strava");